export function sanitizeString(string_) {
  return typeof string_ === 'string' ? string_
    .replaceAll('"', '&quot;')
    .replaceAll('>', '&gt;')
    .replaceAll('<', '&lt;')
    : string_;
}
